// ZOD
import * as z from 'zod';
import {
  JobApplicationFormConfigType,
  JobApplicationFormConfigZod,
} from '@/components/blocks/JobApplicationForm/JobApplicationFormType';

// Utils
import { formatZodError } from '@/utils/error';

// Client
import client from '../client';

export const getFormApplicationConfiguration = async (): Promise<JobApplicationFormConfigType> => {
  const response = await client.get('/api/form-job-application-configuration', {
    params: {
      populate: '*',
    },
  });

  try {
    return await JobApplicationFormConfigZod.parseAsync(response.data?.data);
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(
        `API response do not match Form Application Config structure:\n${formatZodError(error, response.data?.data)}`,
      );
    }
    throw error;
  }
};

interface UploadOptions {
  refId: string;
  ref: string;
  field: string;
  path?: string;
  source?: string;
}

export const uploadMedia = async (file: Blob, options: UploadOptions): Promise<unknown> => {
  try {
    const { refId, ref, field, path, source } = options;
    const formData = new FormData();
    formData.append('files', file);
    formData.append('refId', refId);
    formData.append('ref', ref);
    formData.append('field', field);
    if (path) formData.append('path', path);
    if (source) formData.append('source', source);

    const response = await client.post('/api/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading media:', error);
    throw error;
  }
};
